import { Brick, registerBrick } from 'olympe'

export default class CallProxy extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (headers, path, proxiedPath, payload, token, operation) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} headers
     * @param {string} path
     * @param {string} proxiedPath
     * @param {string} payload
     * @param {string} token
     * @param {string} operation
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(*)} setResponse
     */
    onUpdate(
        context,
        [headers, path, proxiedPath, payload, token, operation],
        [forwardEvent, setErrorFlow, setResponse]
    ) {
        const body = {
            destination: proxiedPath,
            token: token,
            headers: JSON.parse(headers),
            opperation: operation,
            payload: payload,
        }
        fetch(path, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data)
                setResponse(data)
                forwardEvent()
            })
            .catch(error => {
                console.error('Error:', error)
                setErrorFlow(error)
            })
    }
}

registerBrick('017a197bb9a3c8410dde', CallProxy)
